export default "__VITE_ASSET__DxXRW5WA__"